(() => {
  const SAME_HOST = window.location.hostname;

  function isExternalLink(a) {
    if (!a || !a.href) return false;

    const href = a.getAttribute('href') || '';

    // Skip internal anchors and non-http(s) links
    if (href.startsWith('#')) return false;
    if (href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('sms:')) return false;

    // If browser can't parse it as a URL, ignore
    let url;
    try {
      url = new URL(a.href, window.location.origin);
    } catch {
      return false;
    }

    // Only http/https
    if (!/^https?:$/.test(url.protocol)) return false;

    // External host = different hostname
    return url.hostname && url.hostname !== SAME_HOST;
  }

  function applyToLink(a) {
    // Allow opting out per-link if you ever need it:
    // <a ... data-no-newtab="1">
    if (a.hasAttribute('data-no-newtab')) return;

    if (isExternalLink(a)) {
      a.target = '_blank';
      // security best practice when using _blank
      const rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
      if (!rel.includes('noopener')) rel.push('noopener');
      if (!rel.includes('noreferrer')) rel.push('noreferrer');
      a.setAttribute('rel', rel.join(' '));
    }
  }

  function scanAllLinks(root = document) {
    root.querySelectorAll('a[href]').forEach(applyToLink);
  }

  // Initial pass
  document.addEventListener('DOMContentLoaded', () => {
    scanAllLinks();

    // Handle links injected later (apps/sections/AJAX)
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (!(node instanceof Element)) continue;

          if (node.matches?.('a[href]')) applyToLink(node);
          node.querySelectorAll?.('a[href]').forEach(applyToLink);
        }
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  });
})();
